var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1862 37.1742C62.1862 43.8078 59.551 50.1697 54.8604 54.8604C50.1697 59.5511 43.8078 62.1863 37.1742 62.1863C30.5406 62.1863 24.1786 59.5511 19.488 54.8604C14.7973 50.1697 12.1621 43.8078 12.1621 37.1742M62.1862 37.1742C62.1862 30.5406 59.551 24.1787 54.8604 19.488C50.1697 14.7974 43.8078 12.1622 37.1742 12.1622C30.5406 12.1622 24.1786 14.7974 19.488 19.488C14.7973 24.1787 12.1621 30.5406 12.1621 37.1742M62.1862 37.1742H12.1621",
    stroke: "#F12602",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7947 37.1742C46.3222 46.3209 42.9532 55.0803 37.1747 62.1863C31.3962 55.0803 28.0272 46.3209 27.5547 37.1742C28.0272 28.0275 31.3962 19.2681 37.1747 12.1622C42.9532 19.2681 46.3222 28.0275 46.7947 37.1742Z",
    stroke: "#F12602",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web-icon.69d4e74e4defa52f8aeecc04c6f8eff7.svg";
export { ForwardRef as ReactComponent };